<template>
    <label class="checkbox">
        <input
            v-model="localChecked"
            type="checkbox"
            :value="value"
            :disabled="disabled"
            :name="name"
            tabindex="-1"
        >
        <div
            class="icon pointer-events-none"
            tabindex="0"
            @keydown.enter="handleKeydown"
        >
            <font-awesome-icon icon="check" />
        </div>
        <slot />
    </label>
</template>

<script>
    import CheckboxEvent from './CheckboxEvent';

    export default {
        mixins: [CheckboxEvent],
        model: {
            prop: 'checked',
            event: 'input',
        },
        props: {
            checked: {
                required: false,
                type: [Boolean, Array],
                default: false,
            },
            name: {
                required: false,
                type: String,
                default: null,
            },
            value: {
                required: true,
                type: [String, Number],
            },
            disabled: {
                type: Boolean,
                default: false,
            },
        },
        computed: {
            localChecked: {
                get() {
                    return this.checked;
                },
                set(localState) {
                    this.$emit('input', localState);
                },
            },
        },
        methods: {
            handleKeydown(event) {
                if (event.key === 'Enter' && ! this.disabled) {
                    const input = this.$el.querySelector('input[type="checkbox"]');
                    if (input) {
                        input.click();
                    }
                }
            },
        },
    };
</script>
